<template>
  <v-container class="pa-0">
    <v-row class="mt-0 mb-0" align="start" justify="start">
      <v-col
        v-for="(item, i) in TeamDetails"
        :key="i"
        class="text-xs-center"
        cols="6"
        sm="3"
        md="2"
        lg="2"
        style="text-align:center"
      >
        <div class="text-xs-center ma-1 pa-1 py-5 my-0">
          <v-avatar size="100">
            <v-img
              :src="getImgUrl(item.profileImage)"
              :lazy-src="getImgUrl(item.profileImage)"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-avatar>
          <p class="mt-3 mb-0 google-font" style="font-size:130%">
            {{ item.name }}
          </p>
          <p class="mt-1 mb-0 google-font">{{ item.designation }}</p>
          <v-btn
            v-if="item.twitter.length > 0"
            :href="item.twitter"
            target="_blank"
            icon
            class="mt-0 mx-0"
          >
            <v-icon small style="color:#1da1f2">mdi-twitter</v-icon>
          </v-btn>
          <v-btn
            v-if="item.linkedin.length > 0"
            :href="item.linkedin"
            target="_blank"
            icon
            class="mt-0 mx-0"
          >
            <v-icon small style="color:#0077b5">mdi-linkedin</v-icon>
          </v-btn>
          <v-btn
            v-if="item.github.length > 0"
            :href="item.github"
            target="_blank"
            icon
            class="mt-0 mx-0"
          >
            <v-icon small style="color:#333">mdi-github</v-icon>
          </v-btn>
          <v-btn
            v-if="item.website.length > 0"
            :href="item.website"
            target="_blank"
            icon
            class="mt-0 mx-0"
          >
            <v-icon style="color:#333">mdi-link</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TeamDetails from '@/assets/data/coreTeam.json';

export default {
  data() {
    return {
      TeamDetails: TeamDetails,
    };
  },
  methods: {
    getImgUrl(pic) {
      if (pic.length > 0) {
        return require(`@/assets/img/team/${pic}`);
      } else {
        return require('@/assets/img/team/avatar.png');
      }
    },
  },
};
</script>

<style scoped>
.google-font {
  font-family: 'Roboto', sans-serif;
}
</style>
